import Users from '../components/Users/Users';
import Company from '../components/Company/Company';
import Market from '../components/Market/Market';
import CompanyMarket from '../components/CompanyMarket/CompanyMarket';
import Stores from '../components/Stores/Stores';
import Apk from '../components/Application/Application';
import CompanyClient from '../components/CompanyClient/CompanyClient';
import CompanyStat from '../components/Statistics/CompanyStat/CompanyStat';
import StoreStat from '../components/Statistics/StoreStat/StoreStat';
import AppsStat from '../components/Statistics/AppsStat/AppsStat.js';
import Alerts from '../components/Alerts/Alerts';
import Calls from '../components/Promo/Calls/Calls';
import StoresStat from '../components/Statistics/StoresStat/StoresStat';
import SummaryStat from '../components/Statistics/SummaryStat/SummaryStat';
import Offer from '../components/Promo/Offer/Offer';
import OffersPage from '../components/Promo/OffersPage/OffersPage';
import PromoPage from '../components/Promo/PromoPage/PromoPage';
import OfferStatPage from '../components/Promo/OfferStatPage/OfferStatPage';
import PromoVideoCompany from "../components/PromoVideo/PromoVideoCompany";

const companyAdminRoutesAndOffers = [
    {
        collapse: false,
        path: "/",
        name: {
            "ru": "Главная",
            "en": "Main",
            "sk": "Hlavná"
        },
        state: "home",
        icon: "mdi mdi-home",
    },
    {
        navlabel: true,
        companyTitle: true,
        name: {
            "ru": "Администрирование",
            "en": "Administration",
            "sk": "Podávanie"
        },
        icon: "mdi mdi-dots-horizontal",
    },
    {
        collapse: false,
        path: "/dashboard/users",
        name: {
            "ru": "Пользователи",
            "en": "Users",
            "sk": "Užívatelia"
        },
        state: "users",
        icon: "mdi mdi-account-circle",
        component: Users
    },
    {
        collapse: false,
        path: "/dashboard/stores",
        name: {
            "ru": "Торговые точки",
            "en": "Trader points",
            "sk": "Body obchodníka"
        },
        state: "stores",
        icon: "mdi mdi-cart",
        component: Stores
    },
    {
        collapse: false,
        path: "/dashboard/retail",
        name: {
            "ru": "Маркет предприятия",
            "en": "Company market",
            "sk": "Podnikový trh"
        },
        state: "retail",
        icon: "mdi mdi-apps",
        component: CompanyMarket,

    },
    {
        collapse: true,
        path: "/dashboard/statistics",
        name: {
            "ru": "Статистика",
            "en": "Statistics",
            "sk": "Štatistika"
        },
        state: "statistics",
        icon: "mdi mdi-information",
        child: [
            {
                path: "/dashboard/statistics/stores",
                name: {
                    "ru": "По торговым точкам",
                    "en": "By trader points",
                    "sk": "Podľa bodov obchodníka"
                },
                mini: "B",
                icon: "mdi mdi-houzz-box",
                component: StoresStat
            },
            {
                path: "/dashboard/statistics/general",
                name: {
                    "ru": "Общий отчет",
                    "en": "General report",
                    "sk": "Všeobecná správa"
                },
                mini: "B",
                icon: "mdi mdi-houzz-box",
                component: SummaryStat
            },
            {
            	path: "/dashboard/statistics/apps",
            	name: {
            		"ru": "По приложениям",
            		"en": "By apps",
                    "sk": "Podľa aplikácií"
            	},
            	mini: "B",
            	icon: "mdi mdi-animation",
            	component: AppsStat
            },
            /*{
                collapse: false,
                path: "/dashboard/statistics/callstat",
                state: "callstat",
                name: {
                    "ru":"Продвижение",
					"en": "Promotion",
					"sk": "Povýšenie"
                },
                mini: "B",
                icon: "mdi mdi-apps",
                component: CallStatPage,
            },*/
        ]
    },
    {
        collapse: false,
        path: "/dashboard/alerts",
        name: {
            "ru": "Уведомления",
            "en": "Alerts",
            "sk": "Výstrahy"
        },
        state: "alerts",
        icon: "mdi  mdi-message-text-outline",
        component: Alerts
    },
    // {
    // 	collapse: true,
    // 	path: "/dashboard/alerts",
    // 	name: {
    // 		"ru": "Уведомления",
    // 		"en": "Alerts"
    // 	},
    // 	state: "alerts",
    // 	icon: "mdi  mdi-message-text-outline",
    // 	child: [
    // 		{
    // 			path: "/dashboard/alerts/messages",
    // 			name: {
    // 				"ru":"История",
    // 				"en": "History"
    // 			},
    // 			mini: "B",
    // 			icon: "mdi mdi-clipboard-text",
    // 			component: Alerts,
    // 		},
    // 		{
    // 			path: "/dashboard/alerts/notifications",
    // 			name: {
    // 				"ru":"Действия",
    // 				"en": "Actions"
    // 			},
    // 			mini: "B",
    // 			icon: "mdi mdi-alert",
    // 			component: AlertNotifications
    // 		}
    // 	]
    // },
    {
        collapse: true,
        path: "/dashboard/company",
        name: {
            "ru": "Настройки",
            "en": "Settings",
            "sk": "Nastavenie"
        },
        state: "companies",
        icon: "mdi mdi-settings",
        child: [
            {
                path: "/dashboard/company",
                name: {
                    "ru":"Компания",
                    "en": "Company",
                    "sk": "Firma"
                },
                mini: "B",
                icon: "mdi mdi-city",
                component: Company
            },
            {
                path: "/dashboard/client",
                name: {
                    "ru": "Клиент",
                    "en": "Client",
                    "sk": "Klient"
                },
                mini: "B",
                icon: "mdi mdi-library-plus",
                component: CompanyClient
            },
        ]
    },
    {
        collapse: false,
        path: "/dashboard/calls",
        name: {
            "ru": "Офферы",
            "en": "Offers",
            "sk": "Ponuky"
        },
        state: "alerts",
        icon: "mdi  mdi-fire",
        component: Calls
    },
    {
        collapse: false,
        path: "/dashboard/promo/video",
        name: {
            "ru": "Промо видео",
            "en": "Promo video",
            "sk": "Propagačné video"
        },
        state: "promo-video",
        icon: "mdi  mdi-video",
        component: PromoVideoCompany
    },
    {
        collapse: true,
        name: {
            "ru": "Продвижение",
            "en": "Promotion",
            "sk": "Propagácia"
        },
        icon: "mdi mdi-barcode",
        child: [
            {
                path: "/dashboard/repo",
                state: "repo",
                name: {
                    "ru":"Приложения",
                    "en": "Apps",
                    "sk": "Aplikácie"
                },
                mini: "B",
                icon: "mdi mdi-barcode",
                component: PromoPage,
            },
            {
                path: "/dashboard/promo",
                state: "promotion",
                name: {
                    "ru":"Кампании",
                    "en": "Companies",
                    "sk": "Spoločnosti"
                },
                mini: "B",
                icon: "mdi mdi-barcode",
                component: OffersPage,
            },
            {
                collapse: false,
                path: "/dashboard/offerstat",
                state: "offerstat",
                name: {
                    "ru":"Cтатистика - Oфферы",
                    "en": "Statistics - Offers",
                    "sk": "Štatistika - ponuky"
                },
                mini: "B",
                icon: "mdi mdi-apps",
                component: OfferStatPage,
            },
        ]
    },
    {
        collapse: false,
        path: "/chat",
        isLink: true,
        name: {
            "ru": "Поддержка",
            "en": "Support",
            "sk": "Podpora"
        },
        state: "chat",
        icon: "mdi mdi-comment-multiple-outline"
    },
    // {
    //     invisible: true,
    //     collapse: false,
    //     path: "/dashboard/offers/:appid",
    //     state: "offers",
    //     component: OffersPage,
    // },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/offer",
        state: "offer",
        component: Offer,
    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/offer/:offerid",
        state: "offer",
        component: Offer,
    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/market/:appid",
        state: "app",
        component: Apk,
    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/market",
        //name: "Маркет",
        state: "market",
        //icon: "mdi mdi-apps",
        component: Market,

    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/statistics/companies/:companyid",
        state: "company-statistics",
        component: CompanyStat,
    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/statistics/stores/:storeid",
        state: "point-statistics",
        component: StoreStat,
    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/statistics/apps/:appid",
        state: "point-statistics",
        component: AppsStat,
    },
    {
        invisible: true,
        collapse: false,
        path: "/dashboard/statistics/general/:apkid",
        state: "general-statistics",
        component: SummaryStat,
    },
];

export default companyAdminRoutesAndOffers;



// WEBPACK FOOTER //
// ./src/routes/companyAdminRoutesAndOffers.js